import React from 'react';
import { ArrowLeft, FileText, AlertTriangle, Scale, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <Link to="/" className="btn-secondary" style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '8px',
              marginBottom: '32px' 
            }}>
              <ArrowLeft size={16} />
              Back to Home
            </Link>
            <h1 className="hero-large" style={{ marginBottom: '24px' }}>
              Terms & Conditions
            </h1>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              marginBottom: '32px'
            }}>
              Please read these terms and conditions carefully before using Care Pharmacy services.
            </p>
            <div className="body-small" style={{ color: 'var(--text-light)' }}>
              Last Updated: January 2025
            </div>
          </div>
        </div>
      </section>

      {/* Terms Overview */}
      <section className="section-padding-small" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px',
            marginBottom: '60px'
          }}>
            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              borderRadius: '0px',
              textAlign: 'center'
            }}>
              <FileText size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Service Agreement
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Legal agreement governing the use of Care Pharmacy services and products
              </p>
            </div>

            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              borderRadius: '0px',
              textAlign: 'center'
            }}>
              <Scale size={40} style={{ color: 'var(--brand-green)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Rights & Responsibilities
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Clear definition of user and Care Pharmacy rights and obligations
              </p>
            </div>

            <div style={{
              padding: '32px',
              background: 'var(--bg-primary)',
              borderRadius: '0px',
              textAlign: 'center'
            }}>
              <Users size={40} style={{ color: 'var(--brand-blue)', marginBottom: '16px', display: 'inline-block' }} />
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                User Protection
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Guidelines ensuring safe and secure use of pharmaceutical services
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Terms */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            
            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Acceptance of Terms
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  By accessing and using Care Pharmacy services, including our website, mobile applications, and physical stores, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
                </p>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  These terms apply to all users, customers, franchise partners, and visitors of Care Pharmacy services across India.
                </p>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Services Offered
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                marginBottom: '24px'
              }}>
                <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--brand-green)' }}>
                  Pharmaceutical Services
                </h3>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <li className="body-regular">• Prescription medication dispensing and consultation</li>
                  <li className="body-regular">• Over-the-counter medicines and health products</li>
                  <li className="body-regular">• Health and wellness consultations</li>
                  <li className="body-regular">• Home delivery services</li>
                  <li className="body-regular">• Health monitoring and diagnostic tie-ups</li>
                </ul>
              </div>
              
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--brand-blue)' }}>
                  Digital Services
                </h3>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <li className="body-regular">• Online ordering and prescription uploads</li>
                  <li className="body-regular">• WhatsApp ordering and customer support</li>
                  <li className="body-regular">• Digital receipts and medicine reminders</li>
                  <li className="body-regular">• Store locator and franchise information</li>
                  <li className="body-regular">• Health information and educational content</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                User Responsibilities
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                border: '1px solid var(--brand-blue)'
              }}>
                <h3 className="heading-3" style={{ marginBottom: '16px' }}>
                  You Agree To:
                </h3>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <li className="body-regular">• Provide accurate and complete information</li>
                  <li className="body-regular">• Use services only for lawful purposes</li>
                  <li className="body-regular">• Present valid prescriptions from licensed practitioners</li>
                  <li className="body-regular">• Follow medication instructions and safety guidelines</li>
                  <li className="body-regular">• Respect intellectual property rights</li>
                  <li className="body-regular">• Not misuse or abuse our services</li>
                  <li className="body-regular">• Maintain confidentiality of account credentials</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Prescription & Medication Policy
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                border: '1px solid var(--status-warning)'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '16px' }}>
                  <AlertTriangle size={24} style={{ color: 'var(--status-warning)', flexShrink: 0, marginTop: '2px' }} />
                  <div>
                    <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                      Important Medication Guidelines
                    </h3>
                    <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      All prescription medications require valid prescriptions from licensed healthcare providers.
                    </p>
                  </div>
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <li className="body-regular">• Prescriptions must be current and within validity period</li>
                  <li className="body-regular">• We reserve the right to verify prescriptions with healthcare providers</li>
                  <li className="body-regular">• Some medications require additional documentation or ID verification</li>
                  <li className="body-regular">• Controlled substances follow strict regulatory guidelines</li>
                  <li className="body-regular">• We may refuse to dispense if safety concerns arise</li>
                  <li className="body-regular">• All dispensing follows pharmaceutical regulations and standards</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Pricing & Payment
              </h2>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '24px'
              }}>
                <div style={{
                  padding: '24px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)'
                }}>
                  <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                    Pricing Policy
                  </h3>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <li className="body-small">• Competitive pricing with up to 85% discounts</li>
                    <li className="body-small">• Prices may vary by location and availability</li>
                    <li className="body-small">• Special offers subject to terms and conditions</li>
                  </ul>
                </div>
                
                <div style={{
                  padding: '24px',
                  background: 'var(--bg-secondary)',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)'
                }}>
                  <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                    Payment Methods
                  </h3>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <li className="body-small">• Cash, credit/debit cards accepted</li>
                    <li className="body-small">• Digital payments and UPI supported</li>
                    <li className="body-small">• Insurance claims processing available</li>
                  </ul>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Limitation of Liability
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  Care Pharmacy provides pharmaceutical services to the best of our ability and in accordance with professional standards. However:
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <li className="body-regular">• We are not liable for outcomes resulting from proper use of correctly dispensed medications</li>
                  <li className="body-regular">• Customer responsibility to follow medication instructions and consult healthcare providers</li>
                  <li className="body-regular">• We maintain professional indemnity insurance as per regulatory requirements</li>
                  <li className="body-regular">• Liability limited to the cost of products or services provided</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Intellectual Property
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  All content, trademarks, logos, and intellectual property on Care Pharmacy platforms are owned by or licensed to Care Pharmacy Pvt Ltd.
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <li className="body-regular">• Users may not reproduce, distribute, or modify our content without permission</li>
                  <li className="body-regular">• Care Pharmacy name and logo are registered trademarks</li>
                  <li className="body-regular">• All rights reserved unless explicitly stated otherwise</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Franchise Terms
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                border: '1px solid var(--brand-green)'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  Franchise opportunities are subject to separate franchise agreements and terms:
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <li className="body-regular">• Franchise applications subject to approval and verification</li>
                  <li className="body-regular">• Separate franchise agreement governs franchise relationship</li>
                  <li className="body-regular">• Investment amounts and returns as specified in franchise documentation</li>
                  <li className="body-regular">• Ongoing support and training provided per franchise terms</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Termination
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  We reserve the right to terminate or suspend services:
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <li className="body-regular">• For violation of these terms and conditions</li>
                  <li className="body-regular">• For fraudulent or illegal activities</li>
                  <li className="body-regular">• For misuse of prescription services</li>
                  <li className="body-regular">• At our discretion with reasonable notice</li>
                </ul>
              </div>
            </div>

            <div style={{ marginBottom: '48px' }}>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Governing Law
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  These terms and conditions are governed by Indian law. Any disputes will be subject to the exclusive jurisdiction of courts in Ahmedabad, Gujarat. We comply with all applicable pharmaceutical regulations, consumer protection laws, and healthcare guidelines in India.
                </p>
              </div>
            </div>

            <div>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
                Contact Information
              </h2>
              <div style={{
                padding: '32px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px'
              }}>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                  For questions about these terms and conditions, please contact us:
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div className="body-regular">
                    <strong>Legal Department:</strong> +91-6358585323
                  </div>
                  <div className="body-regular">
                    <strong>Email:</strong> carepharmacyindia@gmail.com
                  </div>
                  <div className="body-regular">
                    <strong>Address:</strong> Care Pharmacy Pvt Ltd, Wall Street-2, Opp. Orient Club, Gujarat College Road, Ahmedabad-380006, Gujarat, India
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;